// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1647":"fec77224","7492":"13d108d2"}[chunkId] || chunkId) + "." + {"1280":"7ef4a8478aec2a4b","1647":"178bcbb1a95b8635","4847":"c4b174d9b83a5c83","6821":"e2d806c700679c2a","7492":"3de687ce394ca9c6","8653":"6bcd77b750306cde"}[chunkId] + ".js";
};